import { useEffect, useState } from "react";
import { envData } from "../../envs";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { isMobile } from "react-device-detect";
import Spinner from "../../commonComponents/Spinner";
import { styled } from "@mui/material/styles";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#001F3F",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

import axios from "axios";
function GlobalStudentList() {
  const [globalStudents, setGlobalStudents] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  function filterFinalExams(data) {
    return data.filter(
      (person) =>
        Array.isArray(person.exams) &&
        person.exams.some((exam) =>
          exam?.examName.toLowerCase().includes("final")
        )
    );
  }
  const getStudentInfo = async () => {
    const token = localStorage.getItem("token");
    try {
      const request1 = await axios.get(`${envData.baseApiUrl}/v1/students`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const globalFiltered = filterFinalExams(request1.data);

      setGlobalStudents(globalFiltered);
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };
  useEffect(() => {
    getStudentInfo();
  }, []);
  const filteredAfterSearch = globalStudents.filter((student) =>
    student?.firstName.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return (
    <div
      style={{
        margin: "auto",
        display: "flex",
        width: "90%",
        flexDirection: "column",
      }}
    >
      <input
        style={{ width: isMobile ? "90%" : "50%", margin: "10px 0px" }}
        type="text"
        placeholder="Search by name..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      {globalStudents.length ? (
        <Paper sx={{ width: "100%", overflow: "hidden", marginTop: "5px" }}>
          <TableContainer sx={{ maxHeight: 640 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead style={{ border: "3px solid red" }}>
                <TableRow style={{ border: "3px solid red" }}>
                  <StyledTableCell
                    style={{
                      minWidth: 30,
                      fontWeight: "bold",
                      borderBottom: "2px solid grey",
                    }}
                  >
                    #
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      minWidth: 170,
                      fontWeight: "bold",
                      borderBottom: "2px solid grey",
                    }}
                  >
                    Full Name
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      minWidth: 130,
                      fontWeight: "bold",
                      borderBottom: "2px solid grey",
                    }}
                  >
                    Country
                  </StyledTableCell>
                  <StyledTableCell
                    align="right"
                    style={{
                      minWidth: 140,
                      fontWeight: "bold",
                      borderBottom: "2px solid grey",
                    }}
                  >
                    Email
                  </StyledTableCell>
                  <StyledTableCell
                    align="right"
                    style={{
                      minWidth: 140,
                      fontWeight: "bold",
                      borderBottom: "2px solid grey",
                    }}
                  >
                    Attending Subject
                  </StyledTableCell>

                  <StyledTableCell
                    align="right"
                    style={{
                      minWidth: 20,
                      fontWeight: "bold",
                      borderBottom: "2px solid grey",
                    }}
                  >
                    Grade
                  </StyledTableCell>
                  <StyledTableCell
                    align="right"
                    style={{
                      minWidth: 140,
                      fontWeight: "bold",
                      borderBottom: "2px solid grey",
                    }}
                  >
                    School Name
                  </StyledTableCell>
                  <StyledTableCell
                    align="right"
                    style={{
                      minWidth: 100,
                      fontWeight: "bold",
                      borderBottom: "2px solid grey",
                    }}
                  >
                    DOB
                  </StyledTableCell>
                  <StyledTableCell
                    align="right"
                    style={{
                      minWidth: 110,
                      fontWeight: "bold",
                      borderBottom: "2px solid grey",
                    }}
                  >
                    Phone
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredAfterSearch.map((row, ind) => {
                  const global = row.exams.filter((exam) =>
                    exam.examName.toLowerCase().includes("final")
                  );
                  console.log(global);
                  return (
                    <StyledTableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={row.email}
                    >
                      <StyledTableCell>{ind + 1}</StyledTableCell>
                      <StyledTableCell>
                        {row.firstName + " " + row.lastName}
                      </StyledTableCell>
                      <StyledTableCell>{row.countryName}</StyledTableCell>
                      <StyledTableCell align="right">
                        {row.email}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {global[0]?.finalExamsAttending
                          ? global[0]?.finalExamsAttending.join(",")
                          : "NA"}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {row.grade}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {row.schoolName}
                      </StyledTableCell>
                      <StyledTableCell align="right">{row.dob}</StyledTableCell>
                      <StyledTableCell align="right">
                        {row.phone}
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      ) : (
        <Spinner />
      )}
    </div>
  );
}

export default GlobalStudentList;
